import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming logo.png is in the img folder
import './Thirdpartyservices.css'; // Assuming the CSS is in the same directory
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.

function Mentoring() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };


  return (
    <>
    
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">guidance for success and growth.</h1>
            <p className="banner-description">
              Empower yourself with Shigjeta’s mentoring services. We provide personalized guidance, insights, and support to help you achieve your professional and personal goals.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Third Party Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      {/* Personal Mentoring Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Personal Mentoring</strong></h2>
            <p>
              We offer one-on-one personal mentoring to guide you through challenges, build confidence, and develop key skills to excel in your career and personal life.
            </p>
            <ul>
              <li><strong>Career Development:</strong> Help you discover and achieve your career goals.</li>
              <li><strong>Confidence Building:</strong> Empower you to take on new challenges with confidence.</li>
              <li><strong>Life Coaching:</strong> Provide support to improve work-life balance.</li>
              <li><strong>Networking:</strong> Connect with valuable contacts for professional growth.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ts1.1.png" alt="Personal Mentoring" />
          </div>
        </div>

        {/* Professional Mentoring Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Professional Mentoring</strong></h2>
            <p>
              Our professional mentoring program is designed to help you advance your career, enhance your skills, and make informed decisions in your industry.
            </p>
            <ul>
              <li><strong>Industry Insights:</strong> Get expert advice tailored to your field.</li>
              <li><strong>Skill Enhancement:</strong> Develop key skills for career advancement.</li>
              <li><strong>Leadership Mentorship:</strong> Cultivate leadership qualities and team management skills.</li>
              <li><strong>Decision-Making:</strong> Gain confidence in making critical business decisions.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ts1.2.png" alt="Professional Mentoring" />
          </div>
        </div>

        {/* Group Mentoring Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Group Mentoring</strong></h2>
            <p>
              Join our group mentoring sessions where you can learn from others, exchange experiences, and grow together in a supportive environment.
            </p>
            <ul>
              <li><strong>Collaborative Learning:</strong> Learn from a group of like-minded individuals.</li>
              <li><strong>Peer Support:</strong> Gain different perspectives and share knowledge.</li>
              <li><strong>Group Activities:</strong> Participate in activities that promote team bonding and problem-solving.</li>
              <li><strong>Networking Opportunities:</strong> Build relationships with fellow mentees and professionals.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ts1.3.png" alt="Group Mentoring" />
          </div>
        </div>

        {/* Mentoring Success Stories Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Mentoring Success Stories</strong></h2>
            <p>
              Discover how our mentoring services have helped individuals and professionals grow, overcome challenges, and achieve their goals.
            </p>
            <a href='/blog' className="cta-button">Read Our Mentoring Case Studies</a>
          </div>
          <div className="about-image">
            <img src="/img/ts1.4.png" alt="Mentoring Success Stories" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default Mentoring;
